import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vex-meal-disclaimer',
  templateUrl: './meal-disclaimer.component.html',
  styleUrls: ['./meal-disclaimer.component.scss']
})
export class MealDisclaimerComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<any>, public translate: TranslateService) { }

  ngOnInit() {}

  closeModal() {
    this.dialogRef.close();
  }

}
